import React, { useState, useEffect, useContext } from 'react';
import styled from 'styled-components';
import { db } from '../Firebase/firebase';
import { collection, addDoc, query, orderBy, onSnapshot, serverTimestamp } from 'firebase/firestore';
import { UserAuth } from '../Firebase/authcontext';

export default function GlobalChat() {
    const { user,apploading } = UserAuth();
    const [messages, setMessages] = useState([]);
    const [newMessage, setNewMessage] = useState('');

    useEffect(() => {
        const q = query(collection(db, 'Global_Chat'), orderBy('timestamp', 'asc'));
        const unsubscribe = onSnapshot(q, (snapshot) => {
            setMessages(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
        });
        return () => unsubscribe();
    }, []);

    const sendMessage = async (e) => {
        e.preventDefault();
        if (newMessage.trim() === '') return;

        await addDoc(collection(db, 'Global_Chat'), {
            senderId: user.uid,
            username: user.displayName,
            message: newMessage,
            timestamp: serverTimestamp()
        });
        setNewMessage('');
    };

    return (
        <ChatContainer>
            <ChatMessages>
                {messages.map(msg => (
                    <ChatMessage key={msg.id} ownMessage={msg.senderId === user.uid}>
                        <strong>{msg.username}</strong>: {msg.message}
                    </ChatMessage>
                ))}
            </ChatMessages>
            <ChatForm onSubmit={sendMessage}>
                <ChatInput
                    type="text"
                    value={newMessage}
                    onChange={(e) => setNewMessage(e.target.value)}
                    placeholder="Type a message..."
                />
                <ChatSendButton type="submit">Send</ChatSendButton>
            </ChatForm>
        </ChatContainer>
    );
}

// Styled-components

const ChatContainer = styled.div`
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
    border: 1px solid #ccc;
    border-radius: 10px;
    padding: 10px;
    background-color: #f5f5f5;
    height: 500px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

const ChatMessages = styled.div`
    overflow-y: scroll;
    flex-grow: 1;
    margin-bottom: 10px;
`;

const ChatMessage = styled.div`
    margin: 5px 0;
    padding: 5px 10px;
    border-radius: 5px;
    background-color: ${(props) => (props.ownMessage ? '#dcedc8' : '#e1f5fe')};
    text-align: ${(props) => (props.ownMessage ? 'right' : 'left')};
`;

const ChatForm = styled.form`
    display: flex;
    gap: 10px;
`;

const ChatInput = styled.input`
    flex: 1;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
`;

const ChatSendButton = styled.button`
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    background-color: #0288d1;
    color: white;
    cursor: pointer;

    &:hover {
        background-color: #026aa7;
    }
`;
